import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLike = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M24 41.959 7.769 25.729a11.18 11.18 0 0 1-3.296-7.956c0-3.006 1.17-5.831 3.296-7.956s4.951-3.296 7.956-3.296 5.831 1.171 7.956 3.296l.319.318.318-.318c4.387-4.387 11.526-4.387 15.913 0a11.18 11.18 0 0 1 3.295 7.956c0 3.005-1.17 5.831-3.295 7.956zM15.725 9.521c-2.204 0-4.276.858-5.835 2.417s-2.417 3.631-2.417 5.835.858 4.276 2.417 5.835L24 37.717l14.11-14.109c1.558-1.559 2.417-3.631 2.417-5.835s-.858-4.276-2.417-5.835a8.2 8.2 0 0 0-5.835-2.417 8.2 8.2 0 0 0-5.835 2.417L24 14.377l-2.44-2.439a8.2 8.2 0 0 0-5.835-2.417" }) }) })
});
export default SvgLike;
